import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth45: ToothDataEntry = {
	[ToothView.LINGUAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M29,395c66.9-16.6,100.1,2,100.1,2l6.9,22.9,4,21.1-.8,16.1-1.3,5.1-3.7,4-6.7,4-10.2,3.5-12,3-21.6-.4-19.9-2.8-17.4-2-3.8-.5-9.3-3.2-2.6-1.8-4.4-7.2-1.8-5.3-.9-4.4-.7-6.1v-19.3s1.4-6.1,1.5-6.6,1-6.3,1-6.3l1.6-6.7,1.1-5.8.9-3.3h0Z',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M29,395c66.9-16.6,100.1,2,100.1,2l6.9,22.9,4,21.1-.8,16.1-1.3,5.1-3.7,4-6.7,4-10.2,3.5-12,3-21.6-.4-19.9-2.8-17.4-2-3.8-.5-9.3-3.2-2.6-1.8-4.4-7.2-1.8-5.3-.9-4.4-.7-6.1v-19.3s1.4-6.1,1.5-6.6,1-6.3,1-6.3l1.6-6.7,1.1-5.8.9-3.3h0Z',
			},
			[ToothSurface.CervicalLingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M129.1,397.1l-1.3-6.6c-40.5-19.3-97.1-1.7-97.1-1.7l-1.7,6.2c67.2-16.6,100.1,2,100.1,2h0Z',
			},
			[ToothSurface.Lingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M131.6,407.7s-15.6,0-24,0c-8.4,0-9.3,8-9.3,8v24.4h-37.2s0-16.5,0-24.6-9.6-7.8-9.6-7.8h-25.1s2.5-12.7,2.5-12.7c66.6-17.2,100.1,2,100.1,2,0,0,2.5,10.7,2.5,10.7Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M137.2,423.8l3.2,18.5v14.2s-1.8,5-1.8,5l-3.7,5.3-6.1,4.4-14.2,4.6-16.3,1.7v-61.7s1-8.1,9.3-8.1h24s5.6,16.1,5.6,16.1Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M26.4,407.8l-3.4,14.7-1.2,18.9,1,6.4,2.5,9.5,4.6,8.2,4.8,3.5,8.8,2.6,17.6,2.2s0-33.6,0-33.6v-24.6c0-8.2-9.6-7.8-9.6-7.8h-25.1s-.1,0-.1,0Z',
			},
			[ToothSurface.LingualCusp]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '140.5 440.2 140.5 456.4 137 464 131.9 469.7 122.3 473.7 107.9 476.9 77.1 476.9 63.8 474.4 44.6 472.2 32.1 467.7 30.7 466.3 25.4 458.4 24.3 453.9 23 447.4 22.6 440.2 61.1 440.2 98.3 440.2 140.5 440.2',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'25.3 443.9 36.9 425.9 42.8 450.9 50.6 420.5 60.8 451.7 70.2 420.5 80.6 451.4 90.3 420.5 101 453.2 109.5 422.1 120.9 453.2 124.3 427.1 138.8 443.1',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'75.3 404.1 89.1 395 72.1 386.3 86 377.1 70.3 369 83.5 360.2 69.4 353 82.2 344.5 66 336.2 78.6 328 65.6 321.4 78.2 313.1 64 305.9 77.3 297.1 64 290.4 77.3 281.6 64.8 275.1 77.8 266.6 62.7 258.9 77.9 248.9 63.4 241.3 78.4 231.5 63.3 223.8 78.1 214.1 61.1 205.3 74.6 196.3 57.3 186.6 70.9 173.1 52.8 167.1 62.8 155 44.8 143.5 54.3 128 37.8 125.5 47.8 112 31.8 108 40.8 93.4 26.3 91.4 33.3 79.9 22.3 69.4',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'35 261.4 39.6 251.6 45.2 261.8 50.9 252.7 57.8 261.1 65.9 251.1 73.3 263 82.4 251.6 91.1 263 98.5 252.7 106.2 262.7',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '136.3 92.5 137.2 111.9 135.9 135.6 125.2 155.6 109 171 89 178.6 64.3 178.6 45.1 174.6 28.9 166.9 14.8 151.1 9 135.6 6.3 118.7 6.7 99.7 9.2 80.8 22 51.1 32.5 39.2 50.6 29.4 70.4 27 85.8 29.6 104.3 39 119.1 53.2 132.1 72.4 136.3 92.5',
			},
			[ToothSurface.LingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M127.8,66.3s-4.5,4.2-9.9,8.5-2.6,8.5-15.1,8.5-18.8-9.4-30.9-9.4-20.4,8-32.3,8-9.6-3.4-15.4-7.2-10.6-7.7-10.6-7.7l6.9-14.7,11.6-13.5,16.6-9.2,20-3.1,18.8,3.5,19.4,10.8,14.7,15.1,5.9,10.4h.3Z',
			},
			[ToothSurface.BuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M134.1,138.9s-3.5-4.8-8.7-9.3c-4.7-4.1-3.8-7.9-16.9-7.9-13.1,0-23.9,11.4-36.2,11.4-12.3,0-18.4-9.6-31.9-9.6s-13.1,3.8-18.7,7.8c-6.5,4.7-11.3,9.8-11.3,9.8l4.1,11.2,13.7,14.5,16.8,8,19,4.9,23.7-.4,21.5-8.4,17-16.3,8-15.7h-.1Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M134.2,138.8l-8.7-9.3c-34.4-27.2-7.9-54.7-7.9-54.7l9.9-8.5c16.7,29.2,6.7,72.5,6.7,72.5Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M13.6,66.8c-16.2,44.2-2.9,74.2-2.9,74.2l11.3-9.8c35.5-28.2,2.1-56.6,2.1-56.6l-10.6-7.7h0Z',
			},
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M117.6,74.9c-25.7,30.9,7.9,54.7,7.9,54.7,0,0-3.5-7.9-16.9-7.9s-22.9,11.4-36.2,11.4c-13.3,0-17-9.6-31.9-9.6s-53.9,37-18.7,7.8c35.2-29.2,2.1-56.6,2.1-56.6,0,0,3.6,7.2,15.4,7.2,11.8,0,19.5-8,32.3-8s17.9,9.4,30.9,9.4,15.1-8.5,15.1-8.5h0Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '14.8 150 127.3 150 125.7 155.9 108.3 171.7 87.8 179.6 62.6 179.8 44.8 174.6 27.4 166.3 16.1 154.1 14.8 150',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '20.4 54.4 119.2 54.4 107.9 41.8 98.4 36.6 83.8 28.5 65 27.2 47.7 29.6 32.8 38.7 23.8 48.4 20.4 54.4',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'7.6 105.6 20.8 123.5 27.4 98.6 36.2 129 47.6 97.8 58.3 129 70.1 98.1 81.1 129 92.9 96.2 102.7 127.4 115.4 96.2 119.3 122.4 135.7 106.4',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M128.7,143.3s-58.4,35.4-103.1,2.9l-2.7-11.2-15.5-44.2-1.7-8.6.5-15.5,2.4-9.6,6.7-6.2,18.1-6.4,53.6-8.4h29.6s12.7,2.4,12.7,2.4l9.3,7.2,2.6,5.7,1.2,11.7-2.6,15.5-5.3,26.6-5.9,38.1h0Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M128.7,143.3v12.5c-64,27.7-100.4,4.7-100.4,4.7l-2.8-14.3c44.8,32.5,103.1-2.9,103.1-2.9h.1Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M128.6,143.2l1.9-13h-21.3c-11.9,0-10.9-12.4-10.9-12.4l.4-38.4-47.9.6v39.6c0,10.9-12.3,10.6-12.3,10.6l-17.6.3,4.6,15.7c44.9,32.8,103.1-2.9,103.1-2.9h0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M98.3,118c0,13.6,10.9,12.4,10.9,12.4h21.3s11.2-61.2,11.2-61.2v-16.9s-5.8-10.2-5.8-10.2l-6.2-3.6-15.7-2.8h-15.3s0,43.8,0,43.8l-.4,38.4h0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M38.5,130.3l-17.6.3-13.7-39.3-1.7-8.8v-15.5s.7-5.3.7-5.3l5.5-8.8,21-8.1,18.1-2.8v77.7c0,10.8-12.3,10.6-12.3,10.6Z',
			},
			[ToothSurface.BuccalCusp]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '5.7 80.6 5.7 65.3 6.9 58.7 11.6 52.8 32.1 44.4 83.1 36.2 116.9 35.4 129.4 37.8 138 43.8 141.7 52.8 142.1 63.6 140 79.5 98.7 79.5 50.8 80.1 5.7 80.6',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M128.7,143.3s-58.4,35.4-103.1,2.9l-2.7-11.2-15.5-44.2-1.7-8.6.5-15.5,2.4-9.6,6.7-6.2,18.1-6.4,53.6-8.4h29.6s12.7,2.4,12.7,2.4l9.3,7.2,2.6,5.7,1.2,11.7-2.6,15.5-5.3,26.6-5.9,38.1h0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'8.2 87.5 23.1 106.9 27.8 78 38.9 112 48 75.7 61.2 110.5 70.8 74.6 84.2 108.9 93.7 70.8 105.8 105.6 116.4 69.2 122.3 98.6 137.5 79.4',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'85.8 151 76.8 159 95.5 163.9 80.7 174.1 95.1 179.3 81.8 185.5 94.1 193.4 81 199.5 95.3 208.4 82.7 214.3 94 221.5 81.3 227.5 93.6 235.3 80.3 241.6 92 249 78.5 255.3 94 263.9 82.3 272.8 93.7 279.8 80 286.3 93.1 296.1 77.3 302.2 91.6 311.6 76.6 318.1 89.6 326.3 75.2 334.8 89.1 343.5 74.5 351.1 87.2 361.5 72.1 367.2 85.3 377.4 69.4 383.5 83.3 390.8 65.8 400.3 80.2 407.7 65.6 414.1 77.9 423.6 58.8 437.6',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'47.9 264.1 53 276.9 58.6 263.2 64.7 275.5 71.8 264.1 80.5 277.2 88.2 261.3 97.7 276.4 105.3 261.3 114.6 274.9 120.8 261.3',
			],
		},
	},
};
